import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import { Fine, FineHistorySearchResponse, FineSearchResponse } from "./@types";

export const fineApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFines: builder.mutation<
      ApiSuccessResponse<FineSearchResponse>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/penalties/fine/by-company",
        method: "POST",
        body: { ...data },
      }),
    }),
    getFineById: builder.query<ApiSuccessResponse<Fine>, string>({
      query: (id) => ({
        url: `/v1/fuelLog/getfuelLog/${id}`,
        method: "GET",
      }),
    }),
    createFine: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (data) => ({
        url: "/v1/penalties/fine",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateFine: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (data) => ({
        url: `/v1/penalties/fine/${data.id}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
    deleteFine: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/penalties/fine/${id}`,
        method: "DELETE",
      }),
    }),
    // fine history
    getFineHistory: builder.mutation<
      ApiSuccessResponse<FineHistorySearchResponse>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/penalties/fine-history/by-company",
        method: "POST",
        body: { ...data },
      }),
    }),
    getFineHistoryById: builder.query<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/penalties/fine-history/${id}`,
        method: "GET",
      }),
    }),
    createFineHistory: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/penalties/fine-history",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateFineHistory: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: `/v1/penalties/fine-history/${data.id}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
    deleteFineHistory: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/penalties/fine-history/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetFinesMutation,
  useGetFineByIdQuery,
  useCreateFineMutation,
  useUpdateFineMutation,
  useDeleteFineMutation,
  useGetFineHistoryMutation,
  useGetFineHistoryByIdQuery,
  useCreateFineHistoryMutation,
  useUpdateFineHistoryMutation,
  useDeleteFineHistoryMutation,
} = fineApiSlice;
